import { render, staticRenderFns } from "./editProductDynamic.vue?vue&type=template&id=9906063c&"
import script from "./editProductDynamic.vue?vue&type=script&lang=js&"
export * from "./editProductDynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports